import { render, staticRenderFns } from "./Metrics.vue?vue&type=template&id=b766408e&scoped=true&"
import script from "./Metrics.vue?vue&type=script&lang=js&"
export * from "./Metrics.vue?vue&type=script&lang=js&"
import style0 from "./Metrics.vue?vue&type=style&index=0&id=b766408e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b766408e",
  null
  
)

/* custom blocks */
import block0 from "./Metrics.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports